export default __webpack_public_path__ + "static/media/007-winter hat.8decd6b8.svg";